var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { alias, disgardOldValue, object } from '../../utils/serializr/serializr';
import { Question } from '../../classes/question/Question';
import { QuestionTypeName } from '../../classes/learnware/LearnwareEnums';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { primitive } from '../../utils/serializr/schema/inner/primitive';
import { withInit } from '../../utils/serializr/schema/middle/withInit';
import { MultiSelectStore } from './modules/MultiSelectStore';
import { editable } from '../../utils/mobx/decorators/editable';
import { MultiSelectProgress } from './modules/MultiSelectProgress';
import { MultiSelectScore } from './modules/MultiSelectScore';
export class QuestionMultiSelect extends Question {
    questionType = QuestionTypeName.MultiSelect;
    xy;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get exportingChildren() {
        return [...super.exportingChildren, ...this.selectTasks]; // importing nodes
    }
    get questionScore() {
        return new MultiSelectScore(this);
    }
    multiSelectStore;
    get selectTasks() {
        return this.multiSelectStore.selectTasks;
    }
    get items() {
        return this.selectTasks;
    }
    get tasks() {
        return this.selectTasks;
    }
    get task() {
        return this.multiProgress.currentTask;
    }
    get multiProgress() {
        return new MultiSelectProgress(this);
    }
    static get serializeInfo() {
        return {
            extends: Question.serializeInfo,
            props: {
                questionType: withInit(primitive, QuestionTypeName.MultiSelect),
                multiSelectStore: alias('questionTypeStore', withInit(object(MultiSelectStore), {})),
                textBasis: alias('text', disgardOldValue(primitive)),
            },
        };
    }
}
__decorate([
    editable()
], QuestionMultiSelect.prototype, "questionType", void 0);
__decorate([
    observable
], QuestionMultiSelect.prototype, "xy", void 0);
__decorate([
    memoize
], QuestionMultiSelect.prototype, "questionScore", null);
__decorate([
    memoize
], QuestionMultiSelect.prototype, "multiProgress", null);
__decorate([
    memoize
], QuestionMultiSelect, "serializeInfo", null);
